import { ApiClientAxios, apiFactoryConfig } from "@repo/api";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { ms } from "humanize-ms";

export const useInvestorQuestionnaireConfig = ({
    options,
}: {
    options?: Partial<UseQueryOptions<ApiClientAxios.QuestionnaireConfig>>;
} = {}) => {
    const api = ApiClientAxios.InvestorProfileApiFactory(...apiFactoryConfig);

    return useQuery<ApiClientAxios.QuestionnaireConfig>({
        queryKey: ["questionnaireConfig"],
        queryFn: async () => (await api.getInvestorQuestionnaireConfigGet()).data,
        gcTime: ms("1h"),
        staleTime: ms("1h"),
        ...options,
    });
};
